/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { features, language } from "config";
import { FirebaseContext } from "common";
import AlertDialog from "../../components/AlertDialog";
import { useNavigate } from "react-router-dom";
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";
import { Box } from "@mui/material";
export default function AddPracticeAdmin(props) {
  const { api } = useContext(FirebaseContext);
  const {
    updateProfile,
    editUser,
    deleteUser,
    checkUserExists,
    emailSignUp,
    clearLoginError,
  } = api;
  const [state, setState] = useState({
    userType: "practiceadmin",
    firstName: "",
    lastName: "",
    username: "",
    identityNumber: "",
    referralId: "",
    practiceNumber: "",
    practiceName: "",
    practiceLicenseNumber: "",
    specialityType: "Default",
    bankAccount: "",
    bankCode: "",
    bankName: "",
    bankType: "",
    licenseImage: null,
    doctorImage: null,
    nurseImage: null,
    other_info: "",
    password: "",
    email: "",
  });
  const [isdepdata, setIsdepData] = useState({
    isIndependent: false,
  });
  const specialities = useSelector(
    (state) => state.specialitytypes.specialities
  );
  const [specialityTypes, setSpecialityTypes] = useState({});
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const usersdata = useSelector((state) => state.usersdata);
  const dispatch = useDispatch();
  const navigate= useNavigate();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  useEffect(() => {
    console.log("i am the auth", auth);
    console.log("first", auth.info.profile.practiceNumber);

    if (usersdata.users) {
      setData(
        usersdata.users.filter(
          (user) =>
            user.userType === "practiceadmin" &&
            auth.info.profile.practiceNumber === user.practiceNumber
        )
      );
    } else {
      setData([]);
    }
  }, [usersdata.users]);
  useEffect(() => {
    if (specialities) {
      let obj = {};
      for (let i = 0; i < specialities.length; i++) {
        specialities.map((speciality) => (obj[speciality] = speciality));
      }
      setSpecialityTypes(obj);
    }
  }, []);
  useEffect(() => {
    if (auth.info && auth.info.profile) {
      setIsdepData({
        isIndependent: false,
      });
    }
    console.log("first", auth.info.profile);
  }, [auth.info]);
  const columns = [
    { header: language.first_name, accessorKey: "firstName", initialEditValue: "" },
    { header: language.last_name, accessorKey: "lastName", initialEditValue: "" },
    { header: "Identity Number", accessorKey: "identityNumber", initialEditValue: "" },
    {
      header: "Practice Name",
      accessorKey: "practiceName",
      initialEditValue: "",
      editable: "never",
      render: (rowData) =>
        auth.info.profile.practiceName
          ? rowData.practiceName
          : auth.info.profile.practiceName,
    },
    {
      header: "Department",
      accessorKey: "specialityType",
      lookup: specialityTypes,
    },
    {
      header: language.email,
      accessorKey: "email",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo",
    },
    { header: "password", accessorKey: "password", initialEditValue: "" },
    {
      header: language.mobile,
      accessorKey: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo",
    },
    {
      header: "Private Practice",
      accessorKey: "privatePractice",
      type: "boolean",
      initialEditValue: true,
    },
    {
      header: language.account_approve,
      accessorKey: "practiceAdminActiveStatus",
      type: "boolean",
      initialEditValue: true,
    },
  ];
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  const onRowAdd= (newData) =>{
            new Promise((resolve, reject) => {
              setTimeout(() => {
                checkUserExists(newData).then((res) => {
                  if (res.users && res.users.length > 0) {
                    alert(language.user_exists);
                    reject();
                  } else if (res.error) {
                    alert(language.email_or_mobile_issue);
                    reject();
                  } else {
                    newData["createdByAdmin"] = true;

                    newData["userType"] = "practiceadmin";
                    newData["createdAt"] = new Date().toISOString();
                    newData["referralId"] =
                      newData.firstName.toLowerCase() +
                      Math.floor(1000 + Math.random() * 9000).toString();
                    setState({
                      ...state,
                      newData,
                    });
                    newData["username"] =
                      newData.firstName.toLowerCase() +
                      newData.lastName.toLowerCase() +
                      Math.floor(1000 + Math.random() * 9000).toString();
                    setState({
                      ...state,
                      newData,
                    });
                    let role = auth.info.profile.userType;
                    if (role === "practiceadmin") {
                      newData["practiceadmin"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    } else if (role === "nurse") {
                      newData["nurse"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    } else if (role === "doctor") {
                      newData["doctor"] = auth.info.uid;
                      newData["practiceNumber"] =
                        auth.info.profile.practiceNumber;
                    }
                    dispatch(
                      updateProfile(auth.info, {
                        isIndependent: false,
                        privatePractice: true,
                      })
                    );
                    emailSignUp(newData).then((res) => {
                      resolve();
                      console.log("i am the back data", res);
                      if (res.uid) {
                        setTimeout(() => {
                          setCommonAlert({
                            open: true,
                            msg: language.account_create_successfully,
                          });
                          navigate("/login");
                          console.log(newData);
                        }, 3000);
                      } else {
                        setCommonAlert({
                          open: true,
                          msg: language.reg_error,
                        });
                      }
                    });
                  }
                });
              }, 600);
            })
          };


          const onRowUpdate= (newData, oldData) =>{
            new Promise((resolve) => {
              setTimeout(() => {
                resolve();
                dispatch(editUser(oldData.id, newData));
              }, 600);
            })
          }
          const onRowDelete= (oldData) =>{
            features.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    dispatch(deleteUser(oldData.id));
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(language.demo_mode);
                  }, 600);
                })
              };

  return usersdata.loading ? (
    <CircularLoading />
  ) : (
  <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={data}
      columns={columns}
      userInitialState={{
        columnVisibility: { id: false }, // This hides the "id" column initially
      }}
      onRowAdd={onRowAdd}
      onRowUpdate={onRowUpdate}
      onRowDelete={onRowDelete}
    />
  </Box>
  );
}
